import { c as _c } from "react/compiler-runtime";
import { DigitalResourcesTypeEnum, DigitalResourcesTypeTitles } from 'modules/digital-product/enums/digital-resources-type-enum';
import { resourceTypeIcons } from 'modules/digital-product/resources/constants/resource-type-icons';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';

/**
 * Resource types offered to the user: `downloadable_file` is never selectable here and
 * `systemeio_plan` is a root-admin only option.
 */
export function useDigitalResourceTypes() {
  const $ = _c(6);
  const {
    isRootAdmin
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.values(DigitalResourcesTypeEnum);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isRootAdmin) {
    t1 = t0.filter(type => isRootAdmin ? true : type !== DigitalResourcesTypeEnum.systemeio_plan).filter(_temp);
    $[1] = isRootAdmin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t || $[4] !== t1) {
    t2 = t1.map(type_1 => ({
      id: type_1,
      caption: t(DigitalResourcesTypeTitles[type_1]),
      icon: resourceTypeIcons[type_1]
    }));
    $[3] = t;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(type_0) {
  return type_0 !== DigitalResourcesTypeEnum.downloadable_file;
}